import { render, staticRenderFns } from "./FilesDialog.vue?vue&type=template&id=4dbf5b98&scoped=true&"
import script from "./FilesDialog.vue?vue&type=script&lang=js&"
export * from "./FilesDialog.vue?vue&type=script&lang=js&"
import style0 from "./FilesDialog.vue?vue&type=style&index=0&id=4dbf5b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf5b98",
  null
  
)

export default component.exports